const PAYMENT_LINK_STATUS = {
    PENDING: 1,
    PAID: 2,
    CANCELLED: 3,
    EXPIRED: 4,
}

export { PAYMENT_LINK_STATUS }
export default PAYMENT_LINK_STATUS



// WEBPACK FOOTER //
// ./src/enums/paymentLinkStatus.js